// extracted by mini-css-extract-plugin
module.exports = {"root":"OwnershipInfoPopup_root__dGmi0","title":"OwnershipInfoPopup_title__2Wb4r","description":"OwnershipInfoPopup_description__pQZ_Y"};